// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"7346":"css/admin-app.6758","8918":"css/app.6758"}[chunkId] + ".css";
};